import { render, staticRenderFns } from "./coachRegisterInfoAudit.vue?vue&type=template&id=39741a2a&scoped=true"
import script from "./coachRegisterInfoAudit.vue?vue&type=script&lang=ts"
export * from "./coachRegisterInfoAudit.vue?vue&type=script&lang=ts"
import style0 from "./coachRegisterInfoAudit.vue?vue&type=style&index=0&id=39741a2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39741a2a",
  null
  
)

export default component.exports